import React, { useState, useEffect } from 'react';
import { queryFamiliesByFamilyIdRange } from "../../service/FamilyQueryApi"; // Assuming the API is correctly imported
import '../general/General.css'; // Assuming you have the necessary CSS styles
import { useCheckAccess } from "../../utils/Utilities";

const FamilyList = () => {
  useCheckAccess('FamilyAdmin');
  const [families, setFamilies] = useState([]);  // Ensure families is an empty array initially
  const [loading, setLoading] = useState(false);

  // Pagination state
  const [pageNumber, setPageNumber] = useState(1);  // Default to page 1
  const [pageSize, setPageSize] = useState(50);     // Default to 10 items per page
  const [totalItems, setTotalItems] = useState(0);   // Total number of families (for pagination)
  const [hasSearched, setHasSearched] = useState(false);

  const fetchFamilies = async () => {
    setLoading(true);
    try {
      const payload = { pageNumber, pageSize };
      const response = await queryFamiliesByFamilyIdRange(payload);

      if (response?.families?.length) {
        setFamilies(response.families);
        setTotalItems(response.totalItems || 0);
      } else {
        setFamilies([]);
      }
    } catch (error) {
      console.error("Error fetching families:", error);
      setFamilies([]);
    } finally {
      setLoading(false);
    }
  };

  // Call this inside the form handler:
  const onSubmitSearchByPagination = (e) => {
    e.preventDefault();
    setHasSearched(true);
    fetchFamilies();
  };


  // And use it in useEffect too:
  useEffect(() => {
    if (hasSearched) {
      fetchFamilies();
    }
  }, [pageNumber, pageSize]);


  // Function to render the family table
  const renderFamilyTable = () => {
    if (families.length === 0) {
      return <p>No families found.</p>;
    }
    return (
      <table className="table">
        <thead>
          <tr>
            <th>குடும்ப விவரங்கள்</th>
            <th>குடும்ப தலைவர்</th>
          </tr>
        </thead>
        <tbody>
          {families.map((family) => (
            <tr key={family.id}>

              <td>
                <strong>குடும்ப எண்:</strong> {family.id}{' / '}
                <span style={{ color: family.status !== 'active' ? 'red' : 'black' }}>
                  {family.status}
                </span>
                {' / '}
                {family.kootamName}
                {family.customGroup && (
                  <>
                    <strong>தனித்துவக் குழு:</strong> {family.customGroup}<br />
                  </>
                )}
                <br />
                <strong>வருடம் வரை வரி : </strong>
                {family.pongalTaxUptoYear || " தகவல் இல்லை "}{" "}

                <br />

                {(family.tempAddressName_tamil || family.tempAddressBlock_tamil || family.tempAddressDistrict_tamil) && (
                  <>
                    <strong>தற்காலிக முகவரி:</strong>
                    {family.tempAddressName_tamil && `${family.tempAddressName_tamil}, `}
                    {family.tempAddressBlock_tamil && `${family.tempAddressBlock_tamil}, `}
                    {family.tempAddressDistrict_tamil ? family.tempAddressDistrict_tamil : "N/A"}
                    <br />
                  </>
                )}
                <strong>நிலையான முகவரி:</strong> {family.permanentAddressName_tamil}, {family.permanentAddressBlock_tamil}, {family.permanentAddressDistrict_tamil}
                <br />
                <a href={`/family/view/${family.id}`} target="_blank" rel="noopener noreferrer">
                  பார்க்க
                </a>
                &nbsp;|&nbsp;
                <a href={`/family/update/${family.id}`} target="_blank" rel="noopener noreferrer">
                  திருத்து
                </a>
              </td>
              <td>
                {family.familyHeadFirstName} {family.familyHeadLastName}<br />
                <strong>மொபைல்:</strong> {family.familyHeadMobile}{family.familyHeadMobile2 ? ` / ${family.familyHeadMobile2}` : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  // Handle page navigation (next/previous)
  const handleNextPage = () => {
    if (pageNumber * pageSize < totalItems) {
      setPageNumber(prevPage => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(prevPage => prevPage - 1);
    }
  };

  return (
    <div className="general_parent">
      <div className="general_container">
        <div className="general_body">
          <br />
          <h1>குடும்பப் பட்டியல்</h1>
          <br />

          {/* Form for entering PageSize and submitting */}
          <form onSubmit={onSubmitSearchByPagination}>
            <div>
              <label>Page Size:</label>
              <select
                value={pageSize}
                onChange={(e) => setPageSize(parseInt(e.target.value, 10))}
                className="auth_select"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'ஏற்றுகிறது...' : 'தேடு'}
            </button>
          </form>
          {families.length > 5 && (
            <div className="pagination-controls">
              <button onClick={handlePrevPage} disabled={pageNumber <= 1}>
                Previous
              </button>
              <span>
                Page {pageNumber} of {totalItems ? Math.ceil(totalItems / pageSize) : 1}
              </span>

              <button onClick={handleNextPage} disabled={pageNumber * pageSize >= totalItems}>
                Next
              </button>
            </div>

          )}

          {/* Render the family table */}
          <div>
            {loading ? <p>ஏற்றுகிறது...</p> : renderFamilyTable()}
          </div>

          {families.length > 5 && (
            <div className="pagination-controls">
              <button onClick={handlePrevPage} disabled={pageNumber <= 1}>
                Previous
              </button>
              <span>
                Page {pageNumber} of {totalItems ? Math.ceil(totalItems / pageSize) : 1}
              </span>

              <button onClick={handleNextPage} disabled={pageNumber * pageSize >= totalItems}>
                Next
              </button>
            </div>

          )}
        </div>
      </div>
    </div>
  );
};

export default FamilyList;
